/* radiobuttons */
$(document).on('change', '.field_wrap.__radiobuttons input', function () {
    if ($(this).is(':checked')) {
        $(this)
            .closest('.__radiobuttons')
            .find('.input_wrap > label')
            .removeClass('__checked');
        $(this)
            .parent()
            .addClass('__checked');
    }
});
$('.__radiobuttons input:checked')
    .parent()
    .addClass('__checked');
/* checkboxes */
$(document).on('change', '.field_wrap.__checkboxes input', function () {
    if ($(this).is(':checked')) {
        $(this)
            .parent()
            .addClass('__checked');
    } else {
        $(this)
            .parent()
            .removeClass('__checked');
    }
});
$('.field_wrap.__checkboxes input:checked')
    .parent()
    .addClass('__checked');
$(document).on('click', '.formfield.__radiobuttons label', function () {
    if ($(this).find('input').is(':checked')) {
        $(this)
            .parents('.formfield-input')
            .find('label')
            .removeClass('__checked');
        $(this)
            .addClass('__checked');
    }
});
/* checkbox */
$(document).on('change', '.field_wrap.__checkbox input', function () {
    if ($(this).is(':checked')) {
        $(this)
            .parent()
            .addClass('__checked');
    } else {
        $(this)
            .parent()
            .removeClass('__checked');
    }
});
$('.field_wrap.__checkbox input:checked')
    .parent()
    .addClass('__checked');
$(document).on('change', '.formfield.__checkbox input', function () {
    if ($(this).is(':checked')) {
        $(this)
            .parents('.formfield').find('.formfield-label')
            .addClass('__checked');
    } else {
        $(this)
            .parents('.formfield').find('.formfield-label')
            .removeClass('__checked');
    }
});
$('.formfield.__checkbox input:checked')
    .parents('.formfield').find('.formfield-label')
    .addClass('__checked');

if($('.clearRadiobuttons').length) {
    $('.clearRadiobuttons input[type="radio"]').prop('checked', false);
}



// WEBPACK FOOTER //
// ./packages/OSB/js/modules/formInputs.js